(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1350],{

/***/ 45971:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/non-benefit",
      function () {
        return __webpack_require__(80134);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22522);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31591);
/* harmony import */ var _styles_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64952);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78287);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  visibility: ",
        ";\n  position: ",
        ";\n  display: flex;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin: 0 2px;\n  }\n  p:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 24px 0;\n  position: relative;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var CustomBreadCrumbs = function(param) {
    var visible = param.visible, breadCrumbs = param.breadCrumbs;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var onClickBreadCrumb = function(name) {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .logger */ .kg)({
            pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .getPageName */ .j0)(router),
            eventName: "breadcrumb_".concat(name, "_click")
        });
    };
    var breadCrumbsWithHome = [
        {
            label: "홈",
            url: "/",
            logName: "home"
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(breadCrumbs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        visible: visible,
        id: "breadcrumbs",
        children: breadCrumbsWithHome.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Path, {
                role: "button",
                onClick: function() {
                    return onClickBreadCrumb(item.logName);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: item.label
                            })
                        })
                    }),
                    index !== breadCrumbsWithHome.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            }, item.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomBreadCrumbs);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aed661fe-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "static" : "absolute";
}, _styles_layout__WEBPACK_IMPORTED_MODULE_10__/* .Tablet */ .YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
});
var Path = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aed661fe-1"
})(_templateObject1());
var BreadCrumbsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aed661fe-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__/* .zIndex.BreadCrumb */ .W.BreadCrumb);
CustomBreadCrumbs.Wrapper = BreadCrumbsWrapper;


/***/ }),

/***/ 23773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var ValidationCheck = function(param) {
    var _size = param.size, size = _size === void 0 ? 22 : _size, _fill = param.fill, fill = _fill === void 0 ? "#FD7E14" : _fill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.6177 4.08603C17.308 4.10941 17.0333 4.23068 16.8203 4.43801C16.7884 4.46904 16.6991 4.57074 16.6217 4.66402C16.5444 4.7573 14.562 7.15634 12.2165 9.99522C9.87092 12.8341 7.94719 15.1617 7.94154 15.1677C7.93199 15.1779 7.83829 15.0591 6.61926 13.4912C5.89766 12.5631 5.28336 11.7758 5.25414 11.7416C5.04815 11.5005 4.76686 11.3561 4.42726 11.3171C4.03981 11.2727 3.67174 11.4012 3.385 11.681C3.26909 11.7941 3.18925 11.9037 3.1252 12.0379C3.03536 12.226 2.99499 12.428 3.002 12.6544C3.01031 12.9231 3.08506 13.1368 3.24943 13.3616C3.29208 13.42 6.06564 16.9865 6.13862 17.0768C6.20396 17.1577 6.35713 17.3121 6.4381 17.3787C7.01938 17.8566 7.7708 18.0264 8.49981 17.8445C8.94568 17.7333 9.36276 17.4771 9.67163 17.1248C9.72674 17.062 18.6401 6.27711 18.7207 6.17582C18.859 6.00194 18.9475 5.80736 18.9848 5.59522C19.0002 5.50737 19.0033 5.32047 18.9909 5.21907C18.9532 4.91081 18.8316 4.66495 18.612 4.4526C18.337 4.18674 17.988 4.05808 17.6177 4.08603Z",
            fill: fill
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ValidationCheck);


/***/ }),

/***/ 71305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var HealthMedicalMedicines = function(param) {
    var _height = param.height, height = _height === void 0 ? 16 : _height, _width = param.width, width = _width === void 0 ? 16 : _width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_6240_2327)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.6198 6.84864C11.207 6.26149 12.0032 5.93164 12.8336 5.93164C13.6639 5.93164 14.4603 6.26149 15.0475 6.84864C15.6346 7.43578 15.9645 8.23211 15.9645 9.06245C15.9645 9.8928 15.6346 10.6891 15.0475 11.2763L11.2545 15.0691C10.6674 15.6563 9.87107 15.9862 9.04072 15.9862C8.21038 15.9862 7.41405 15.6563 6.82691 15.0691C6.23976 14.4821 5.90991 13.6857 5.90991 12.8553C5.90991 12.025 6.23976 11.2287 6.82691 10.6415L10.6198 6.84864Z",
                        fill: "#EF990D"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.8335 5.93164C12.0031 5.93164 11.2069 6.26149 10.6197 6.84864L8.72327 8.74508L13.1509 13.1727L15.0474 11.2763C15.6345 10.6891 15.9644 9.8928 15.9644 9.06245C15.9644 8.23211 15.6345 7.43578 15.0474 6.84864C14.4602 6.26149 13.6638 5.93164 12.8335 5.93164Z",
                        fill: "#F4B54F"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.43509 8.87016C6.8845 8.87016 8.87016 6.8845 8.87016 4.43509C8.87016 1.98566 6.8845 0 4.43509 0C1.98566 0 0 1.98566 0 4.43509C0 6.8845 1.98566 8.87016 4.43509 8.87016Z",
                        fill: "#339AF0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0.0572177 5.14927H8.81294C8.85059 4.91675 8.87016 4.67815 8.87016 4.43499C8.87016 4.19182 8.85059 3.95324 8.81294 3.7207H0.0572177C0.0195689 3.95324 0 4.19182 0 4.43499C0 4.67815 0.0195689 4.91675 0.0572177 5.14927Z",
                        fill: "#86C6FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_6240_2327",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HealthMedicalMedicines);


/***/ }),

/***/ 79125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_atom_icon_SmallDelete__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70691);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);
/* harmony import */ var _utils_airbridge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);






var AppInstallTopBanner = function(param) {
    var onClickClose = param.onClickClose, content = param.content, trackingInfo = param.trackingInfo, onLogEvent = param.onLogEvent;
    var ref = trackingInfo !== null && trackingInfo !== void 0 ? trackingInfo : {}, contentCategory = ref.contentCategory, contentId = ref.contentId, contentTitle = ref.contentTitle, campaign = ref.campaign, contentSubCategory = ref.contentSubCategory;
    var onClickInstallApp = function() {
        onLogEvent === null || onLogEvent === void 0 ? void 0 : onLogEvent();
        _utils_airbridge__WEBPACK_IMPORTED_MODULE_3__/* ["default"].setDynamicLink */ .Z.setDynamicLink((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            campaign: campaign,
            content: content,
            term: "앱 열기",
            sub_id: contentId,
            sub_id_1: contentTitle,
            sub_id_2: contentCategory
        }, contentSubCategory && {
            sub_id_3: contentSubCategory
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sticky top-[60px] z-[300] flex w-full items-center justify-between bg-gray-700 pt-[14px] pr-[20px] pb-[12px] pl-[12px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: onClickClose,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_SmallDelete__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            color: _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.gray300 */ .Z.color.gray300,
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "typography-ui-13m text-white",
                                children: "병원 문 닫은 늦은 밤, 주말에도"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "typography-ui-15sb text-white",
                                children: "닥터나우는 24시간 열려있어요!"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "typography-ui-13m h-[32px] rounded-lg border bg-primary-600 px-[8px] text-white",
                    onClick: onClickInstallApp,
                    children: "바로 진료받기"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppInstallTopBanner);


/***/ }),

/***/ 29305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_MaterialIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17986);
/* harmony import */ var _components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39535);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44376);
/* harmony import */ var _utils_style__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76666);
/* harmony import */ var doctornow_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59950);
/* harmony import */ var qrcode_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84059);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 24px;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var DiagnosisAppInstallBottomSheet = function(param) {
    var buttonId = param.buttonId, _treatmentMedicineId = param.treatmentMedicineId, treatmentMedicineId = _treatmentMedicineId === void 0 ? "0" : _treatmentMedicineId, qrCodeUrl = param.qrCodeUrl, invitationCode = param.invitationCode, treatmentProductMedicineName = param.treatmentProductMedicineName, onClose = param.onClose, client = param.client, onClickOpenAppInstallLink = param.onClickOpenAppInstallLink, onClickCopyInvitationCode = param.onClickCopyInvitationCode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        isOpened: true,
        onClickOverlay: onClose,
        index: 20,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (0,_utils_style__WEBPACK_IMPORTED_MODULE_7__.cn)("flex flex-col gap-[24px] p-[24px_20px_32px]", client.isMobile && "gap-[20px]"),
            children: [
                client.isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "typography-ui-22sb whitespace-pre-line text-gray-900",
                            children: [
                                "닥터나우 앱을 설치하고",
                                "\n",
                                treatmentProductMedicineName,
                                " 처방 저렴하게 받으세요!"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            className: "h-[144px] object-contain",
                            src: "https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/non_benefit_invitation.png",
                            alt: "계산서 이미지"
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "typography-ui-22sb whitespace-pre-line text-gray-900",
                            children: [
                                "QR코드를 스캔해 앱을 설치하고",
                                "\n",
                                treatmentProductMedicineName,
                                " 처방 저렴하게 받으세요!"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QRCodeWrapper, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(qrcode_react__WEBPACK_IMPORTED_MODULE_6__/* .QRCodeCanvas */ .Qd, {
                                value: qrCodeUrl,
                                size: 120
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "flex flex-col gap-[12px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "flex flex-col items-center gap-[8px] rounded-[8px] bg-gray-20 py-[24px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "typography-ui-15m text-gray-500",
                                    children: "추천 코드"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "flex items-center gap-[8px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "typography-ui-20sb text-gray-900",
                                            children: invitationCode
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                            onClick: onClickCopyInvitationCode,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_MaterialIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                name: "file_copy",
                                                filled: true,
                                                size: 16,
                                                color: _styles_theme__WEBPACK_IMPORTED_MODULE_4__/* ["default"].color.gray300 */ .Z.color.gray300
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: "typography-ui-15r text-center text-gray-600",
                            children: "가입 시 추천 코드를 입력해주세요."
                        })
                    ]
                }),
                client.isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(doctornow_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                    id: buttonId ? buttonId : "selected-medicine-".concat(treatmentMedicineId),
                    className: "mt-[40px] w-full",
                    size: "xl",
                    onClick: onClickOpenAppInstallLink,
                    children: "앱에서 최저가 확인하기"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DiagnosisAppInstallBottomSheet);
var QRCodeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2bbaabc0-0"
})(_templateObject());


/***/ }),

/***/ 98796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useGetNonBenefitDiagnosisPriceSupportInvitationCode; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/entities/non-benefit/hooks/non-benefit.gql.impl.tsx


var GetNonBenefitDiagnosisPriceSupportInvitationCodeDocument = "\n    query getNonBenefitDiagnosisPriceSupportInvitationCode {\n  getNonBenefitDiagnosisPriceSupportInvitationCode {\n    code\n  }\n}\n    ";
var useGetNonBenefitDiagnosisPriceSupportInvitationCodeQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)(variables === undefined ? [
        "getNonBenefitDiagnosisPriceSupportInvitationCode"
    ] : [
        "getNonBenefitDiagnosisPriceSupportInvitationCode",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(GetNonBenefitDiagnosisPriceSupportInvitationCodeDocument, "getNonBenefitDiagnosisPriceSupportInvitationCode", variables), options);
};
useGetNonBenefitDiagnosisPriceSupportInvitationCodeQuery.getKey = function(variables) {
    return variables === undefined ? [
        "getNonBenefitDiagnosisPriceSupportInvitationCode"
    ] : [
        "getNonBenefitDiagnosisPriceSupportInvitationCode",
        variables
    ];
};
useGetNonBenefitDiagnosisPriceSupportInvitationCodeQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(GetNonBenefitDiagnosisPriceSupportInvitationCodeDocument, "getNonBenefitDiagnosisPriceSupportInvitationCode", variables, options);
};

;// CONCATENATED MODULE: ./src/entities/non-benefit/hooks/useGetNonBenefitDiagnosisPriceSupportInvitationCode.ts

var parseGetNonBenefitDiagnosisPriceSupportInvitationCode = function(data) {
    var ref;
    var ref1;
    return (ref1 = (ref = data.getNonBenefitDiagnosisPriceSupportInvitationCode) === null || ref === void 0 ? void 0 : ref.code) !== null && ref1 !== void 0 ? ref1 : "";
};
var useGetNonBenefitDiagnosisPriceSupportInvitationCode = function() {
    var data = useGetNonBenefitDiagnosisPriceSupportInvitationCodeQuery({}, {
        select: parseGetNonBenefitDiagnosisPriceSupportInvitationCode
    }).data;
    return {
        invitationCode: data
    };
};
/* harmony default export */ var hooks_useGetNonBenefitDiagnosisPriceSupportInvitationCode = (useGetNonBenefitDiagnosisPriceSupportInvitationCode);


/***/ }),

/***/ 72105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _models_ad_list__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70847);
/* harmony import */ var _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53476);
/* harmony import */ var _ad_useAdBanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28844);





var useAppInstallTopBanner = function(client) {
    var isVisible = (0,recoil__WEBPACK_IMPORTED_MODULE_3__.useRecoilValue)(_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__/* .appInstallTopBannerState */ .Ep).isVisible;
    var ref = (0,_ad_useAdBanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_models_ad_list__WEBPACK_IMPORTED_MODULE_0__/* .AdPageType.TopCtaBand */ .hO.TopCtaBand, client, true), bannerAdExchange = ref.bannerAdExchange, handleSendExposureLog = ref.handleSendExposureLog;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__/* .getAppInstallTopBannerState */ ._l)();
    }, []);
    return {
        bannerAdExchange: bannerAdExchange,
        handleSendExposureLog: handleSendExposureLog,
        isVisible: isVisible,
        hideBanner: _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__/* .hideBanner */ .dl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAppInstallTopBanner);


/***/ }),

/***/ 96159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ useNonBenefitMedicinesForSeoQuery; },
/* harmony export */   "X9": function() { return /* binding */ useNonBenefitPriceTotalSummaryQuery; },
/* harmony export */   "Y1": function() { return /* binding */ useNonBenefitMapNearbyPharmacySearchTabsQuery; },
/* harmony export */   "Y6": function() { return /* binding */ useSearchNonF2fDoctorsForSeoByUserQuery; }
/* harmony export */ });
/* unused harmony exports NonBenefitMedicinesForSeoDocument, NonBenefitPriceTotalSummaryDocument, SearchNonF2fDoctorsForSeoByUserDocument, NonBenefitMapNearbyPharmacySearchTabsDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var NonBenefitMedicinesForSeoDocument = "\n    query NonBenefitMedicinesForSeo {\n  nonBenefitMedicinesForSeo {\n    id\n    medicineName\n    medicineDescription\n    units {\n      id\n      unit\n      unitType\n      unitTypeDisplayName\n    }\n    treatment {\n      id\n      categoryId\n      isBenefit\n      name\n    }\n  }\n}\n    ";
var useNonBenefitMedicinesForSeoQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "NonBenefitMedicinesForSeo"
    ] : [
        "NonBenefitMedicinesForSeo",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMedicinesForSeoDocument, "NonBenefitMedicinesForSeo", variables), options);
};
useNonBenefitMedicinesForSeoQuery.getKey = function(variables) {
    return variables === undefined ? [
        "NonBenefitMedicinesForSeo"
    ] : [
        "NonBenefitMedicinesForSeo",
        variables
    ];
};
useNonBenefitMedicinesForSeoQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMedicinesForSeoDocument, "NonBenefitMedicinesForSeo", variables, options);
};
var NonBenefitPriceTotalSummaryDocument = "\n    query NonBenefitPriceTotalSummary($treatmentMedicineId: ID!, $regionCode: String!) {\n  nonBenefitPriceTotalSummary(\n    treatmentMedicineId: $treatmentMedicineId\n    regionCode: $regionCode\n  ) {\n    nationalSummaries {\n      averagePrice\n      minPrice\n      treatmentMedicineUnitId\n      unitDisplayName\n      unitTypeDisplayName\n    }\n    regionSummaries {\n      averagePrice\n      minPrice\n      treatmentMedicineUnitId\n      unitDisplayName\n      unitTypeDisplayName\n    }\n  }\n}\n    ";
var useNonBenefitPriceTotalSummaryQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "NonBenefitPriceTotalSummary",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitPriceTotalSummaryDocument, "NonBenefitPriceTotalSummary", variables), options);
};
useNonBenefitPriceTotalSummaryQuery.getKey = function(variables) {
    return [
        "NonBenefitPriceTotalSummary",
        variables
    ];
};
useNonBenefitPriceTotalSummaryQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitPriceTotalSummaryDocument, "NonBenefitPriceTotalSummary", variables, options);
};
var SearchNonF2fDoctorsForSeoByUserDocument = "\n    query SearchNonF2fDoctorsForSeoByUser($request: NonF2fDoctorSeoSearchRequestInput!, $contactType: DiagnosisContactType!) {\n  searchNonF2fDoctorsForSeoByUser(request: $request) {\n    doctorId\n    name\n    medicineType\n    readyForVideoCall\n    publicId\n    nonBenefitTreatmentsV2(contactType: $contactType) {\n      nonBenefitTreatmentUnitInfos {\n        originalPrice\n        unitDisplayName\n        treatmentMedicineUnitId\n      }\n    }\n    detail {\n      profileImageUrl\n    }\n    departments {\n      name\n      isProfessional\n    }\n    hospital {\n      hospitalName\n      hospitalAddress {\n        jibunAddress\n        roadAddress\n        regionByDepth {\n          siDoName\n          siGunGuName\n          legalEupMyeonDongName\n        }\n      }\n    }\n  }\n}\n    ";
var useSearchNonF2fDoctorsForSeoByUserQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchNonF2fDoctorsForSeoByUser",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchNonF2fDoctorsForSeoByUserDocument, "SearchNonF2fDoctorsForSeoByUser", variables), options);
};
useSearchNonF2fDoctorsForSeoByUserQuery.getKey = function(variables) {
    return [
        "SearchNonF2fDoctorsForSeoByUser",
        variables
    ];
};
useSearchNonF2fDoctorsForSeoByUserQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchNonF2fDoctorsForSeoByUserDocument, "SearchNonF2fDoctorsForSeoByUser", variables, options);
};
var NonBenefitMapNearbyPharmacySearchTabsDocument = "\n    query NonBenefitMapNearbyPharmacySearchTabs {\n  nonBenefitMapNearbyPharmacySearchTabs {\n    id\n    name\n    diagnosisType\n    diagnosisTypeId\n    sortTypes {\n      type\n      title\n    }\n    filters {\n      type\n      title\n      description\n      mode\n      activeIconUrl\n      inactiveIconUrl\n      subFilters {\n        type\n        title\n        description\n        mode\n        inactiveIconUrl\n        activeIconUrl\n      }\n    }\n    treatmentMedicines {\n      id\n      treatmentId\n      name\n      description\n      dispensationUnits {\n        isDefault\n        dispensationUnit\n        dispensationUnitDisplayName\n        treatmentMedicineId\n        treatmentMedicineUnitId\n      }\n      treatmentMedicineStrengths {\n        treatmentMedicineStrengthId\n        unit\n        treatmentMedicineId\n        isDefault\n      }\n    }\n  }\n}\n    ";
var useNonBenefitMapNearbyPharmacySearchTabsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "NonBenefitMapNearbyPharmacySearchTabs"
    ] : [
        "NonBenefitMapNearbyPharmacySearchTabs",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMapNearbyPharmacySearchTabsDocument, "NonBenefitMapNearbyPharmacySearchTabs", variables), options);
};
useNonBenefitMapNearbyPharmacySearchTabsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "NonBenefitMapNearbyPharmacySearchTabs"
    ] : [
        "NonBenefitMapNearbyPharmacySearchTabs",
        variables
    ];
};
useNonBenefitMapNearbyPharmacySearchTabsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMapNearbyPharmacySearchTabsDocument, "NonBenefitMapNearbyPharmacySearchTabs", variables, options);
};


/***/ }),

/***/ 80134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ non_benefit; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/CustomBreadCrumbs.tsx
var CustomBreadCrumbs = __webpack_require__(12429);
// EXTERNAL MODULE: ./src/components/atom/Divider.tsx
var Divider = __webpack_require__(47064);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
// EXTERNAL MODULE: ./src/components/atom/icon/layout/HealthMedicalMedicines.tsx
var HealthMedicalMedicines = __webpack_require__(71305);
// EXTERNAL MODULE: ./src/components/common/AdExchangeComponent.tsx + 1 modules
var AdExchangeComponent = __webpack_require__(72873);
// EXTERNAL MODULE: ./src/components/common/LinkTag/index.tsx
var LinkTag = __webpack_require__(23889);
// EXTERNAL MODULE: ./src/components/common/communication/magazine/ListMagazineLine.tsx + 2 modules
var ListMagazineLine = __webpack_require__(79476);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Common/AppInstallTopBanner.tsx
var AppInstallTopBanner = __webpack_require__(79125);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Qna/QnaDetailMobileTemplate/QnaRelatedQuestion/RelatedQuestionItem/index.tsx
var RelatedQuestionItem = __webpack_require__(22260);
// EXTERNAL MODULE: ./src/components/atom/icon/ValidationCheck.tsx
var ValidationCheck = __webpack_require__(23773);
// EXTERNAL MODULE: ./src/constants/nonBenefit/index.ts
var nonBenefit = __webpack_require__(2935);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/NonBenefitCategoryInformation.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 24px 8px;\n  white-space: pre-line;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px 12px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 3px;\n  width: 22px;\n  height: 22px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & ul {\n    margin-top: 8px;\n    & > li {\n      position: relative;\n      ",
        ";\n      color: ",
        ";\n      list-style: none;\n      margin-left: 20px;\n      &::before {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: -10px;\n        width: 3px;\n        height: 3px;\n        border-radius: 50%;\n        background-color: ",
        ";\n        transform: translate(-3px, -50%);\n      }\n    }\n  }\n  & p {\n    ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var NonBenefitCategoryInformation = function(param) {
    var selectedMedicine = param.selectedMedicine;
    if (!nonBenefit/* NON_BENEFIT_INFORMATIONS */.S["".concat(selectedMedicine.id)]) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryInformationArticle, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryInformationHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryInformationTitle, {
                    children: "".concat(selectedMedicine.treatmentProductMedicineName, " 처방 받기 전 체크리스트")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryInformationContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryInformationList, {
                    children: nonBenefit/* NON_BENEFIT_INFORMATIONS */.S["".concat(selectedMedicine.id)].map(function(information) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryInformationListItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ValidationCheck/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationDetailWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationTitle, {
                                            children: information.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationContent, {
                                            dangerouslySetInnerHTML: {
                                                __html: information.description
                                            }
                                        })
                                    ]
                                })
                            ]
                        }, "non-benefit-category-info-".concat(selectedMedicine.id, "-").concat(information.title));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_NonBenefitCategoryInformation = (NonBenefitCategoryInformation);
var CategoryInformationArticle = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-468809b5-0"
})(_templateObject());
var CategoryInformationHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-468809b5-1"
})(_templateObject1());
var CategoryInformationTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-468809b5-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI22SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});
var CategoryInformationContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-468809b5-3"
})(_templateObject3());
var CategoryInformationList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-468809b5-4"
})(_templateObject4());
var CategoryInformationListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-468809b5-5"
})(_templateObject5());
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-468809b5-6"
})(_templateObject6());
var InformationDetailWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-468809b5-7"
})(_templateObject7());
var InformationTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-468809b5-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.typography.UI17SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var InformationContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-468809b5-9"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});

// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/NonBenefitSearchDoctorItem.tsx

function NonBenefitSearchDoctorItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 2px;\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    padding: 0 4px;\n    background-color: ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 2px;\n  height: 20px;\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 72px;\n  height: 72px;\n  background-image: url(",
        ");\n  background-size: cover;\n  border-radius: 50%;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}






var NonBenefitSearchDoctorItem = function(param) {
    var doctor = param.doctor, onClick = param.onClick, lastItem = param.lastItem, treatmentMedicineUnitId = param.treatmentMedicineUnitId, cheapestPrice = param.cheapestPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonBenefitDoctorItemWrapper, {
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorInfoWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorNameWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorName, {
                                        children: doctor.doctorDisplayName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorHospitalName, {
                                        children: doctor.hospitalName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorMedicinePriceWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorMedicinePrice, {
                                        cheapest: doctor.isCheapestTreatmentPrice(treatmentMedicineUnitId, cheapestPrice),
                                        children: doctor.getNonBenefitTreatmentPriceTextByTreatmentMedicineUnitId(treatmentMedicineUnitId)
                                    }),
                                    doctor.isCheapestTreatmentPrice(treatmentMedicineUnitId, cheapestPrice) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorMedicinePriceCheepWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "local_offer",
                                                size: 14,
                                                filled: true,
                                                color: theme/* default.color.primary700 */.Z.color.primary700
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorMedicinePriceCheap, {
                                                children: "닥터나우 최저가"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorAddress, {
                                children: doctor.hospitalAddress
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorDepartmentWrapper, {
                                children: [
                                    doctor.professionalDepartments.map(function(department) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorDepartment, {
                                            children: [
                                                department.name,
                                                " 전문의"
                                            ]
                                        }, "department-".concat(department.name));
                                    }),
                                    doctor.readyForVideoCall && /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorVideoCall, {
                                        children: "영상진료"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorProfileImage, {
                        src: doctor.profileImageUrl
                    })
                ]
            }),
            !lastItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                color: theme/* default.color.gray40 */.Z.color.gray40
            })
        ]
    });
};
/* harmony default export */ var components_NonBenefitSearchDoctorItem = (NonBenefitSearchDoctorItem);
var EmptyDoctorItem = function(param) {
    var cheapestPrice = param.cheapestPrice, hospitalAddress = param.hospitalAddress, profileImageUrl = param.profileImageUrl, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonBenefitDoctorItemWrapper, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorInfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorNameWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorEmptyTitle, {
                                children: "앱에서 상세 정보 확인 가능"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "chevron_right",
                                color: theme/* default.color.gray300 */.Z.color.gray300,
                                size: 24,
                                filled: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorMedicinePriceWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorMedicinePrice, {
                                cheapest: true,
                                children: [
                                    (0,format/* formatPriceComma */.dM)(cheapestPrice),
                                    "원"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorMedicinePriceCheepWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                        name: "local_offer",
                                        size: 14,
                                        filled: true,
                                        color: theme/* default.color.primary700 */.Z.color.primary700
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorMedicinePriceCheap, {
                                        children: "닥터나우 최저가"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorAddress, {
                        children: hospitalAddress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorDepartmentWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorVideoCall, {
                            children: "영상진료"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorProfileImage, {
                src: profileImageUrl
            })
        ]
    });
};
NonBenefitSearchDoctorItem.Empty = EmptyDoctorItem;
var NonBenefitDoctorItemWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-9ec87f30-0"
})(NonBenefitSearchDoctorItem_templateObject());
var DoctorInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9ec87f30-1"
})(NonBenefitSearchDoctorItem_templateObject1());
var DoctorNameWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9ec87f30-2"
})(NonBenefitSearchDoctorItem_templateObject2());
var DoctorName = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-9ec87f30-3"
})(NonBenefitSearchDoctorItem_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI16SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var DoctorHospitalName = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9ec87f30-4"
})(NonBenefitSearchDoctorItem_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray300;
});
var DoctorMedicinePriceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9ec87f30-5"
})(NonBenefitSearchDoctorItem_templateObject5());
var DoctorMedicinePrice = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9ec87f30-6"
})(NonBenefitSearchDoctorItem_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.typography.UI18SB;
}, function(param) {
    var theme = param.theme, cheapest = param.cheapest;
    return cheapest ? theme.color.primary700 : theme.color.gray700;
});
var DoctorMedicinePriceCheepWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9ec87f30-7"
})(NonBenefitSearchDoctorItem_templateObject7());
var DoctorMedicinePriceCheap = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9ec87f30-8"
})(NonBenefitSearchDoctorItem_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.typography.UI12SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.primary700;
});
var DoctorAddress = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9ec87f30-9"
})(NonBenefitSearchDoctorItem_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.typography.UI12M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray300;
});
var DoctorDepartmentWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-9ec87f30-10"
})(_templateObject10());
var DoctorDepartment = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-9ec87f30-11"
})(_templateObject12(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), theme.typography.UI12M, theme.color.blue600, theme.color.blue100);
});
var DoctorVideoCall = (0,styled_components_browser_esm/* default */.ZP)(DoctorDepartment).withConfig({
    componentId: "sc-9ec87f30-12"
})(_templateObject14(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject13(), theme.color.gray300, theme.color.gray30);
});
var DoctorProfileImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9ec87f30-13"
})(_templateObject15(), function(props) {
    return props.src;
});
var DoctorEmptyTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9ec87f30-14"
})(_templateObject17(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject16(), theme.typography.UI16SB, theme.color.gray300);
});

;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/NonBenefitSearchDoctorList.tsx

function NonBenefitSearchDoctorList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n"
    ]);
    NonBenefitSearchDoctorList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var NonBenefitSearchDoctorList = function(param) {
    var list = param.list, ListEmptyComponent = param.ListEmptyComponent, renderItem = param.renderItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NonBenefitDoctorListWrapper, {
        children: list.length > 0 ? list.map(function(doctor, i) {
            return renderItem(doctor, i === list.length - 1);
        }) : ListEmptyComponent
    });
};
/* harmony default export */ var components_NonBenefitSearchDoctorList = (NonBenefitSearchDoctorList);
var NonBenefitDoctorListWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-87656a5a-0"
})(NonBenefitSearchDoctorList_templateObject());

;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/NonBenefitTotalSummaryTable.tsx

function NonBenefitTotalSummaryTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 24px;\n"
    ]);
    NonBenefitTotalSummaryTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    NonBenefitTotalSummaryTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  width: 100%;\n"
    ]);
    NonBenefitTotalSummaryTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    color: ",
        ";\n  "
    ]);
    NonBenefitTotalSummaryTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  height: 32px;\n  ",
        "\n"
    ]);
    NonBenefitTotalSummaryTable_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    color: ",
        ";\n    white-space: ",
        ";\n    height: ",
        "px;\n    text-align: center;\n  "
    ]);
    NonBenefitTotalSummaryTable_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  ",
        "\n"
    ]);
    NonBenefitTotalSummaryTable_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var NonBenefitTotalSummaryTable = function(param) {
    var nonBenefitPriceTotalSummary = param.nonBenefitPriceTotalSummary, selectedAddressTitle = param.selectedAddressTitle, selectedMedicine = param.selectedMedicine;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryTableWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryTableHead, {
                                children: "가격비교"
                            }),
                            selectedMedicine.units.map(function(unit) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableHead, {
                                    children: [
                                        unit.unitDisplayName,
                                        " 처방"
                                    ]
                                }, "unit-".concat(unit.id));
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryTableData, {
                                    children: "".concat(selectedAddressTitle, " \n최저가")
                                }),
                                nonBenefitPriceTotalSummary.regionSummaries.map(function(regionSummary) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableData, {
                                        cheapest: true,
                                        children: [
                                            (0,format/* formatPriceComma */.dM)(regionSummary.minPrice),
                                            "원"
                                        ]
                                    }, "region-min-".concat(regionSummary.unitDisplayName));
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryTableData, {
                                    children: "".concat(selectedAddressTitle, " \n평균가")
                                }),
                                nonBenefitPriceTotalSummary.regionSummaries.map(function(regionSummary) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableData, {
                                        children: [
                                            (0,format/* formatPriceComma */.dM)(regionSummary.averagePrice),
                                            "원"
                                        ]
                                    }, "region-avg-".concat(regionSummary.unitDisplayName));
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryTableData, {
                                    children: "전국 \n평균가"
                                }),
                                nonBenefitPriceTotalSummary.nationalSummaries.map(function(nationalSummary) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableData, {
                                        children: [
                                            (0,format/* formatPriceComma */.dM)(nationalSummary.averagePrice),
                                            "원"
                                        ]
                                    }, "national-avg-".concat(nationalSummary.unitDisplayName));
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_NonBenefitTotalSummaryTable = (NonBenefitTotalSummaryTable);
var SummaryTableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-146f1060-0"
})(NonBenefitTotalSummaryTable_templateObject());
var SummaryTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-146f1060-1"
})(NonBenefitTotalSummaryTable_templateObject1());
var SummaryTableRow = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    componentId: "sc-146f1060-2"
})(NonBenefitTotalSummaryTable_templateObject2());
var SummaryTableHead = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
    componentId: "sc-146f1060-3"
})(NonBenefitTotalSummaryTable_templateObject4(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitTotalSummaryTable_templateObject3(), theme.typography.UI15R, theme.color.gray100, theme.color.gray20, theme.color.gray500);
});
var SummaryTableData = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-146f1060-4"
})(NonBenefitTotalSummaryTable_templateObject6(), function(param) {
    var theme = param.theme, cheapest = param.cheapest;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitTotalSummaryTable_templateObject5(), theme.typography.UI15R, theme.color.gray100, theme.color.white, cheapest ? theme.color.primary600 : theme.color.gray500, theme.client.isMobile ? "pre-line" : "normal", theme.client.isMobile ? 48 : 32);
});

// EXTERNAL MODULE: ./src/components/templates/nonBenefit/home/components/RelatedKeywordContentList.tsx
var RelatedKeywordContentList = __webpack_require__(34785);
// EXTERNAL MODULE: ./src/components/templates/nonBenefit/home/components/SearchAddressFilterModal.tsx
var SearchAddressFilterModal = __webpack_require__(8457);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/SearchBar.tsx

function SearchBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: center;\n  padding: 16px 12px;\n  height: 48px;\n  border-radius: 8px;\n  background-color: ",
        ";\n  cursor: pointer;\n  & > p {\n    ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    SearchBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var SearchBar = function(props) {
    var title = props.title, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarWrapper, {
        role: "button",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                name: "expand_more",
                size: 24,
                color: theme/* default.color.gray900 */.Z.color.gray900
            })
        ]
    });
};
/* harmony default export */ var components_SearchBar = (SearchBar);
var SearchBarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b16cc8f8-0"
})(SearchBar_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray900;
});

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/NonBenefitHomeTemplate.tsx


function NonBenefitHomeTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: ",
        "px 24px;\n  "
    ]);
    NonBenefitHomeTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 32px;\n  justify-content: center;\n"
    ]);
    NonBenefitHomeTemplate_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    NonBenefitHomeTemplate_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitHomeTemplate_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        ";\n    color: ",
        ";\n    white-space: pre-line;\n  "
    ]);
    NonBenefitHomeTemplate_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitHomeTemplate_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0 24px;\n  gap: 16px;\n  margin-bottom: 20px;\n"
    ]);
    NonBenefitHomeTemplate_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    NonBenefitHomeTemplate_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  padding: 0 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 56px;\n  width: 100%;\n"
    ]);
    NonBenefitHomeTemplate_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n  "
    ]);
    NonBenefitHomeTemplate_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  height: 48px;\n  border-radius: 12px;\n"
    ]);
    NonBenefitHomeTemplate_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-bottom: 1px solid ",
        ";\n  "
    ]);
    NonBenefitHomeTemplate_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitHomeTemplate_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-bottom: 1px solid ",
        ";\n  "
    ]);
    NonBenefitHomeTemplate_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n\n  margin-top: 40px;\n  ",
        "\n"
    ]);
    NonBenefitHomeTemplate_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-bottom: 1px solid ",
        ";\n  "
    ]);
    NonBenefitHomeTemplate_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitHomeTemplate_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-bottom: 1px solid ",
        ";\n  "
    ]);
    NonBenefitHomeTemplate_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: ",
        ";\n    align-items: ",
        ";\n    justify-content: ",
        ";\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  padding: 0 24px;\n  margin-bottom: 40px;\n  gap: 52px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    white-space: pre-line;\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    white-space: pre-line;\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 80px;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    margin-bottom: 8px;\n  "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    margin-bottom: 4px;\n  "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0;\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 24px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-line;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n  margin-bottom: 42px;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 24px;\n  ",
        "\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  padding: 0 24px;\n  margin-bottom: 40px;\n"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 40px;\n"
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 35px 24px 0;\n"
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 189px;\n  padding: 59px 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin: 0 24px;\n\n  border-radius: 12px;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),\n    url('https://file.doctornow.co.kr/non-benefit/non_benefit_map_thumbnail.png') lightgray 0 -0.013px / 117.448% 380.437%\n      no-repeat;\n"
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n\n  ",
        "\n"
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 40px;\n  padding: 0px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  flex-shrink: 0;\n\n  border-radius: 8px;\n  background: ",
        ";\n"
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 8px;\n  gap: 8px;\n"
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}

























var NonBenefitHomeTemplate = function(param) {
    var client = param.client, viewModel = param.viewModel, topBannerViewModel = param.topBannerViewModel;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB && topBannerViewModel.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                style: {
                    top: 60
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default */.Z, {
                    enableAnimation: true,
                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInstallTopBanner/* default */.Z, {
                        onLogEvent: viewModel.onClickTopCta,
                        content: "web_top_bnr_main",
                        onClickClose: topBannerViewModel.hideBanner,
                        trackingInfo: {
                            campaign: "web_nonbenefit",
                            contentTitle: viewModel.selectedMedicine.medicineName
                        }
                    }),
                    bannerAdExchange: topBannerViewModel.bannerAdExchange,
                    onImpressionLog: topBannerViewModel.handleSendExposureLog,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default.Content */.Z.Content, {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default.BandCta */.Z.BandCta, {
                            onClose: topBannerViewModel.hideBanner
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default */.Z, {
                    visible: !client.isMobile,
                    breadCrumbs: viewModel.breadCrumbs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchFilterSection, {
                        className: "mt-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NonBenefitTitle, {
                                        children: "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 최저가 가격 ").concat(viewModel.selectedMedicine.medicineName, " ").concat(viewModel.selectedMedicine.medicineDescription, " 2025")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NonBenefitDescription, {
                                        children: "닥터나우에서 ".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 성지 병원의 진료 가격을 비교한 결과,\n 최저가 ").concat(viewModel.selectedMedicine.treatment.name, " 진료비는 ").concat((0,format/* formatPriceComma */.dM)(viewModel.selectedRegionSummary.minPrice), "원이에요.")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarListWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchBar, {
                                        title: "".concat(viewModel.selectedAddressTitle),
                                        onClick: viewModel.onOpenSearchAddressFilterModal
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchBar, {
                                        title: "".concat(viewModel.selectedMedicine.medicineName),
                                        onClick: viewModel.onOpenMedicineFilterModal
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchBar, {
                                        title: "".concat(viewModel.selectedMedicineUnit.unitDisplayName),
                                        onClick: viewModel.onOpenMedicineUnitFilterModal
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSummarySection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                href: "".concat(common/* ROUTES.NON_BENEFIT.MAP.path */.Z6.NON_BENEFIT.MAP.path, "?diagnosisTypeId=").concat((ref = viewModel.selectedMedicine.treatment) === null || ref === void 0 ? void 0 : ref.id, "&treatmentMedicineId=").concat(viewModel.selectedMedicine.id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapBannerWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MapBannerText, {
                                            children: "근처 최저가 약국을 찾고 싶다면?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MapBannerButton, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapBannerButtonLabel, {
                                                children: [
                                                    viewModel.selectedMedicine.treatmentProductMedicineName,
                                                    " 최저가 약국 찾기",
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSummaryWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSummaryInfoWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSummaryTitle, {
                                                children: "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 \n 최저가 진료 가격은\n ").concat(viewModel.priceDisplayGapText)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSummaryDescription, {
                                                children: "닥터나우에서 조회된 ".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방\n성지 병원의 ").concat(viewModel.selectedMedicineUnit.unitDisplayName, " 진료 가격이에요.")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSummaryPricesWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryPriceWrapper, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryPriceMinTitle, {
                                                        children: "최저가"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryPriceMin, {
                                                        children: [
                                                            (0,format/* formatPriceComma */.dM)(viewModel.selectedRegionSummary.minPrice),
                                                            "원"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryExcludeMedicine, {
                                                        children: "약 가격 미포함"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryPriceWrapper, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryPriceTitle, {
                                                        children: "평균가"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryPrice, {
                                                        children: [
                                                            (0,format/* formatPriceComma */.dM)(viewModel.selectedRegionSummary.averagePrice),
                                                            "원"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryExcludeMedicine, {
                                                        children: "약 가격 미포함"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchTotalSummarySection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryHeader, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchTotalSummaryTitleWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryTitle, {
                                            children: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 성지 진료 가격 비교 (").concat(viewModel.selectedMedicine.medicineProductName, ")")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchTotalSummaryDescriptionWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryDescription, {
                                                    children: "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 성지 병원의 가격 비교예요.")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryDescription, {
                                                    children: "닥터나우 앱에서 ".concat(viewModel.selectedAddressTitle, "과(와) 전국의 ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 가격을 비교하고 비대면 진료 받아보세요.")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummarySubTitle, {
                                children: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 비대면 진료 가격")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitTotalSummaryTable, {
                                nonBenefitPriceTotalSummary: viewModel.nonBenefitPriceTotalSummary,
                                selectedAddressTitle: viewModel.selectedAddressTitle,
                                selectedMedicine: viewModel.selectedMedicine
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryButton, {
                                    onClick: viewModel.onOpenDiagnosisAppInstallBottomSheet,
                                    children: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 최저가를 확인하고 싶다면?")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default */.Z, {
                                fallback: null,
                                bannerAdExchange: viewModel.bannerAdExchange,
                                onImpressionLog: viewModel.handleSendExposureLog,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdExchangeComponent/* default.Content */.Z.Content, {
                                    className: (0,style.cn)("w-full px-[24px]", {
                                        "pb-[20px]": client.isMobile,
                                        "py-[20px]": !client.isMobile
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default.ImageAd */.Z.ImageAd, {
                                            className: (0,style.cn)("w-full rounded-[16px]", {
                                                "aspect-[720/120]": !client.isMobile,
                                                "aspect-[312/96]": client.isMobile
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default.DeliberatedCode */.Z.DeliberatedCode, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorHeader, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchDoctorTitleWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorTitle, {
                                            children: "".concat(viewModel.selectedAddressTitle, " 성지 병원\n").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 비대면 진료 가격 정보")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorDescription, {
                                            children: "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 성지 병원의 ").concat(viewModel.selectedMedicineUnit.unitDisplayName, " 비대면 진료 가격이에요.\n닥터나우에서는 ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, "을 전화로 편하게 받을 수 있어요.")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitSearchDoctorList, {
                                list: viewModel.nonBenefitDoctors,
                                ListEmptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitSearchDoctorItem.Empty, {
                                    hospitalAddress: viewModel.selectedFullAddressTitle,
                                    cheapestPrice: viewModel.selectedRegionSummary.minPrice,
                                    profileImageUrl: "https://file.doctornow.co.kr/doctors/default_profile.png",
                                    onClick: viewModel.onOpenDiagnosisAppInstallBottomSheet
                                }),
                                renderItem: function(doctor, lastItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitSearchDoctorItem, {
                                        doctor: doctor,
                                        cheapestPrice: viewModel.selectedRegionSummary.minPrice,
                                        treatmentMedicineUnitId: viewModel.selectedMedicineUnit.id,
                                        lastItem: lastItem,
                                        onClick: function() {
                                            return viewModel.onClickDoctor(doctor, viewModel.selectedMedicine);
                                        }
                                    }, "doctor-".concat(doctor.doctorId));
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorListButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorListButton, {
                                    onClick: viewModel.onOpenDiagnosisAppInstallBottomSheet,
                                    children: "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 성지 병원 보러가기")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedKeywordContentList/* default */.Z, {
                            list: viewModel.faqs,
                            title: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 자주 묻는 질문"),
                            renderItem: function(faq, isLast) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                    href: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faq.magazinePid),
                                    onClickNavigateToScreen: function() {
                                        return viewModel.onClickRelatedFaq(faq.magazinePid);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLine/* default */.Z, {
                                        titleAsH2: false,
                                        magazine: {
                                            title: faq.title,
                                            mobileTitle: faq.title,
                                            image: "",
                                            date: faq.createdDate,
                                            magazinePid: faq.magazinePid,
                                            description: faq.description,
                                            mobileDescription: faq.mobileDescription
                                        },
                                        isLast: isLast
                                    })
                                }, "faq-".concat(faq.magazinePid));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedKeywordContentList/* default */.Z, {
                            list: viewModel.magazines,
                            title: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 건강 매거진"),
                            renderItem: function(magazine, isLast) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                    href: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid),
                                    onClickNavigateToScreen: function() {
                                        return viewModel.onClickRelatedMagazine(magazine.magazinePid);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLine/* default */.Z, {
                                        titleAsH2: false,
                                        magazine: {
                                            title: magazine.title,
                                            mobileTitle: magazine.title,
                                            image: magazine.titleImageUrl,
                                            date: magazine.createdDate,
                                            magazinePid: magazine.magazinePid,
                                            description: magazine.description,
                                            mobileDescription: magazine.mobileDescription
                                        },
                                        isLast: isLast
                                    })
                                }, "magazine-".concat(magazine.magazinePid));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MagazineSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedKeywordContentList/* default */.Z, {
                                list: viewModel.qnas,
                                title: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 의료진 상담"),
                                renderItem: function(qna, isLast) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                        href: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(qna.question.questionPid),
                                        onClickNavigateToScreen: function() {
                                            viewModel.onClickRelatedQuestion(qna.question.questionPid);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedQuestionItem/* default */.Z, {
                                            onClickRelatedQna: function() {
                                                viewModel.onClickRelatedQuestion(qna.question.questionPid);
                                            },
                                            questionCard: qna,
                                            isLast: isLast
                                        })
                                    }, "content_related_qna_".concat(qna.question.questionPid));
                                }
                            }),
                            viewModel.isEnableQnaPagination && /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaMoreButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaMoreButton, {
                                    onClick: viewModel.onClickNextQna,
                                    children: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 의료진 상담 더 보기")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitCategoryInformation, {
                            selectedMedicine: viewModel.selectedMedicine
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyButtonWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default.Button */.Z.Button, {
                                    text: "".concat(viewModel.selectedMedicine.treatmentProductName, " 진료 1,000원 할인받기"),
                                    onClick: viewModel.onOpenDiagnosisAppInstallBottomSheet
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextArea, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthMedicalMedicines/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                                    children: "오늘 "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedEventText, {
                                                    children: "1,379명"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                                    children: "이 ".concat(viewModel.selectedMedicine.treatment.name, "약 처방받았어요")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            viewModel.isAddressFilterModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAddressFilterModal/* default */.Z, (0,_object_spread/* default */.Z)({}, viewModel.getSearchAddressFilterModalProps()))
        ]
    });
};
/* harmony default export */ var home_NonBenefitHomeTemplate = (NonBenefitHomeTemplate);
var TitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-0"
})(NonBenefitHomeTemplate_templateObject1(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject(), _$theme.client.isMobile ? 0 : 2);
});
var NonBenefitTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-9c2c32cd-1"
})(NonBenefitHomeTemplate_templateObject3(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject2(), _$theme.typography.UI22SB, _$theme.color.gray900);
});
var NonBenefitDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9c2c32cd-2"
})(NonBenefitHomeTemplate_templateObject5(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject4(), _$theme.typography.UI15R, _$theme.color.gray500);
});
var SearchBarListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-3"
})(NonBenefitHomeTemplate_templateObject6());
var SearchButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-9c2c32cd-4"
})(NonBenefitHomeTemplate_templateObject8(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject7(), _$theme.typography.UI17SB, _$theme.color.white, _$theme.color.gray700);
});
var SearchLargeButton = (0,styled_components_browser_esm/* default */.ZP)(SearchButton).withConfig({
    componentId: "sc-9c2c32cd-5"
})(NonBenefitHomeTemplate_templateObject10(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject9(), _$theme.typography.UI16SB);
});
var SearchFilterSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-9c2c32cd-6"
})(NonBenefitHomeTemplate_templateObject12(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject11(), _$theme.color.gray50);
});
var SearchSummarySection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-9c2c32cd-7"
})(NonBenefitHomeTemplate_templateObject14(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject13(), _$theme.color.gray50);
});
var SearchDoctorSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-9c2c32cd-8"
})(NonBenefitHomeTemplate_templateObject16(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject15(), _$theme.color.gray50);
});
var SearchTotalSummarySection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-9c2c32cd-9"
})(_templateObject18(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject17(), _$theme.color.gray50);
});
var SearchSummaryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-10"
})(_templateObject20(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject19(), _$theme.client.isMobile ? "column" : "row", _$theme.client.isMobile ? "flex-start" : "center", _$theme.client.isMobile ? "flex-start" : "space-between");
});
var SearchSummaryInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-11"
})(_templateObject21());
var SearchSummaryTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-9c2c32cd-12"
})(_templateObject23(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject22(), _$theme.typography.UI22SB, _$theme.color.gray700);
});
var SearchSummaryDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9c2c32cd-13"
})(_templateObject25(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject24(), _$theme.typography.UI15R, _$theme.color.gray500);
});
var SearchSummaryPricesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-14"
})(_templateObject26());
var SummaryPriceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-15"
})(_templateObject27());
var SummaryPriceTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9c2c32cd-16"
})(_templateObject29(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject28(), _$theme.typography.UI17SB, _$theme.color.gray600);
});
var SummaryPriceMinTitle = (0,styled_components_browser_esm/* default */.ZP)(SummaryPriceTitle).withConfig({
    componentId: "sc-9c2c32cd-17"
})(_templateObject30(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.primary600;
});
var SummaryPrice = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9c2c32cd-18"
})(_templateObject32(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject31(), _$theme.typography.UI26SB, _$theme.color.gray800);
});
var SummaryPriceMin = (0,styled_components_browser_esm/* default */.ZP)(SummaryPrice).withConfig({
    componentId: "sc-9c2c32cd-19"
})(_templateObject33(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.primary700;
});
var SummaryExcludeMedicine = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9c2c32cd-20"
})(_templateObject35(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject34(), _$theme.typography.UI14R, _$theme.color.gray300);
});
var StickyButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-21"
})(_templateObject36());
var SearchDoctorHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-22"
})(_templateObject37());
var SearchDoctorTitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-23"
})(_templateObject38());
var SearchDoctorTitle = (0,styled_components_browser_esm/* default */.ZP)(SearchSummaryTitle).withConfig({
    componentId: "sc-9c2c32cd-24"
})(_templateObject39());
var SearchDoctorDescription = (0,styled_components_browser_esm/* default */.ZP)(SearchSummaryDescription).withConfig({
    componentId: "sc-9c2c32cd-25"
})(_templateObject40());
var SearchDoctorListButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-26"
})(_templateObject41());
var SearchDoctorListButton = (0,styled_components_browser_esm/* default */.ZP)(SearchLargeButton).withConfig({
    componentId: "sc-9c2c32cd-27"
})(_templateObject43(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject42(), _$theme.color.gray600, _$theme.color.white, _$theme.color.gray100);
});
var SearchTotalSummaryHeader = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorHeader).withConfig({
    componentId: "sc-9c2c32cd-28"
})(_templateObject44());
var SearchTotalSummaryTitleWrapper = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorTitleWrapper).withConfig({
    componentId: "sc-9c2c32cd-29"
})(_templateObject45());
var SearchTotalSummaryTitle = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorTitle).withConfig({
    componentId: "sc-9c2c32cd-30"
})(_templateObject46());
var SearchTotalSummaryDescriptionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-31"
})(_templateObject47());
var SearchTotalSummaryDescription = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorDescription).withConfig({
    componentId: "sc-9c2c32cd-32"
})(_templateObject48());
var SearchTotalSummarySubTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-9c2c32cd-33"
})(_templateObject50(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject49(), _$theme.typography.UI17SB, _$theme.color.gray600);
});
var SearchTotalSummaryButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-34"
})(_templateObject51());
var SearchTotalSummaryButton = (0,styled_components_browser_esm/* default */.ZP)(SearchLargeButton).withConfig({
    componentId: "sc-9c2c32cd-35"
})(_templateObject53(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject52(), _$theme.color.primary800, _$theme.color.primary100);
});
var MagazineSection = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorSection).withConfig({
    componentId: "sc-9c2c32cd-36"
})(_templateObject54());
var QnaMoreButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-37"
})(_templateObject55());
var QnaMoreButton = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorListButton).withConfig({
    componentId: "sc-9c2c32cd-38"
})(_templateObject56());
var MapBannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-39"
})(_templateObject57());
var MapBannerText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-40"
})(_templateObject58(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.white;
}, function(param) {
    var _$theme = param.theme;
    return _$theme.typography.UI20SB;
});
var MapBannerButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-41"
})(_templateObject59(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.primary600;
});
var MapBannerButtonLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-42"
})(_templateObject60(), theme/* default.color.white */.Z.color.white, function(param) {
    var _$theme = param.theme;
    return _$theme.typography.UI14SB;
});
var EventTextArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c2c32cd-43"
})(_templateObject61());
var EventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-9c2c32cd-44"
})(_templateObject62(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI15M, ";\n    color: ").concat(_$theme.color.gray500, ";\n  ");
});
var HighlightedEventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-9c2c32cd-45"
})(_templateObject63(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI15SB, ";\n    color: ").concat(_$theme.color.primary700, ";\n  ");
});
var EventTextWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-9c2c32cd-46"
})(_templateObject64());

// EXTERNAL MODULE: ./src/hooks/Cuj/useAppInstallTopBanner.tsx
var useAppInstallTopBanner = __webpack_require__(72105);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./src/components/templates/nonBenefit/home/components/DiagnosisAppInstallBottomSheet.tsx
var DiagnosisAppInstallBottomSheet = __webpack_require__(29305);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/NonBenefitFilterModal.tsx

function NonBenefitFilterModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: ",
        "px;\n    background-color: ",
        ";\n  "
    ]);
    NonBenefitFilterModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  border-radius:24px;\n  padding: 24px 0 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    NonBenefitFilterModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    padding: 0 24px;\n  "
    ]);
    NonBenefitFilterModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitFilterModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    NonBenefitFilterModal_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & > p {\n      ",
        "\n      color: ",
        ";\n    }\n  "
    ]);
    NonBenefitFilterModal_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  height: 56px;\n  padding: 12px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n"
    ]);
    NonBenefitFilterModal_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var NonBenefitFilterModal = function(props) {
    var title = props.title, list = props.list, selectedItem = props.selectedItem, onClick = props.onClick, getItemName = props.getItemName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterModalWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterModalTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList, {
                children: list.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter, {
                        onClick: function() {
                            return onClick(item);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: getItemName(item)
                            }),
                            selectedItem.id === item.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "check",
                                size: 32,
                                color: theme/* default.color.primary500 */.Z.color.primary500
                            })
                        ]
                    }, "filter-".concat(getItemName(item)));
                })
            })
        ]
    });
};
/* harmony default export */ var components_NonBenefitFilterModal = (NonBenefitFilterModal);
var FilterModalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-86c8749e-0"
})(NonBenefitFilterModal_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitFilterModal_templateObject(), theme.client.isMobile ? 300 : 560, theme.color.white);
});
var FilterModalTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-86c8749e-1"
})(NonBenefitFilterModal_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitFilterModal_templateObject2(), theme.typography.UI20SB, theme.color.gray800);
});
var FilterList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-86c8749e-2"
})(NonBenefitFilterModal_templateObject4());
var Filter = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-86c8749e-3"
})(NonBenefitFilterModal_templateObject6(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitFilterModal_templateObject5(), theme.typography.UI16SB, theme.color.gray700);
});

// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/entities/non-benefit/hooks/useGetNonBenefitDiagnosisPriceSupportInvitationCode.ts + 1 modules
var useGetNonBenefitDiagnosisPriceSupportInvitationCode = __webpack_require__(98796);
// EXTERNAL MODULE: ./src/hooks/ad/useAdBanner.ts + 3 modules
var useAdBanner = __webpack_require__(28844);
// EXTERNAL MODULE: ./src/hooks/hospital/search/useSearchKoreaAddressV2.ts
var useSearchKoreaAddressV2 = __webpack_require__(75527);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/nonBenefit/nonBenefit.gql.impl.tsx
var nonBenefit_gql_impl = __webpack_require__(96159);
// EXTERNAL MODULE: ./src/models/nonBenefit/index.ts + 1 modules
var models_nonBenefit = __webpack_require__(30958);
;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitMedicinesForSeo.ts




var parseNonBenefitMedicinesForSeo = function(data) {
    var medicines = data.nonBenefitMedicinesForSeo.map(function(nonBenefitMedicine) {
        var _medicineDescription;
        return new models_nonBenefit/* NonBenefitMedicine */.Vp({
            id: nonBenefitMedicine.id,
            medicineName: nonBenefitMedicine.medicineName,
            medicineDescription: (_medicineDescription = nonBenefitMedicine.medicineDescription) !== null && _medicineDescription !== void 0 ? _medicineDescription : "",
            units: nonBenefitMedicine.units.map(function(unit) {
                return {
                    id: unit.id,
                    unit: unit.unit,
                    unitType: unit.unitType,
                    unitTypeDisplayName: unit.unitTypeDisplayName
                };
            }),
            treatment: {
                id: nonBenefitMedicine.treatment.id,
                name: nonBenefitMedicine.treatment.name,
                isBenefit: nonBenefitMedicine.treatment.isBenefit,
                categoryId: nonBenefitMedicine.treatment.categoryId
            }
        });
    });
    return new models_nonBenefit/* NonBenefitMedicines */._x(medicines);
};
var useNonBenefitMedicinesForSeo = function() {
    var ref = (0,nonBenefit_gql_impl/* useNonBenefitMedicinesForSeoQuery */.Ee)({}, {
        select: parseNonBenefitMedicinesForSeo,
        refetchOnMount: false
    }), tmp = ref.data, nonBenefitMedicines = tmp === void 0 ? new models_nonBenefit/* NonBenefitMedicines */._x([]) : tmp, isLoading = ref.isLoading;
    return {
        isLoading: isLoading,
        nonBenefitMedicines: nonBenefitMedicines
    };
};
var fetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.fetchQuery(nonBenefit_gql_impl/* useNonBenefitMedicinesForSeoQuery.getKey */.Ee.getKey({}), nonBenefit_gql_impl/* useNonBenefitMedicinesForSeoQuery.fetcher */.Ee.fetcher({}))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        parseNonBenefitMedicinesForSeo(response)
                    ];
            }
        });
    });
    return function fetchQuery(queryClient) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var nonBenefit_useNonBenefitMedicinesForSeo = (useNonBenefitMedicinesForSeo);
useNonBenefitMedicinesForSeo.fetchQuery = fetchQuery;

;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitPriceTotalSummary.ts




var parseNonBenefitPriceTotalSummary = function(data) {
    var nationalSummaries = data.nonBenefitPriceTotalSummary.nationalSummaries.map(function(nationalSummary) {
        return {
            averagePrice: nationalSummary.averagePrice,
            minPrice: nationalSummary.minPrice,
            treatmentMedicineUnitId: nationalSummary.treatmentMedicineUnitId,
            unitDisplayName: nationalSummary.unitDisplayName,
            unitTypeDisplayName: nationalSummary.unitTypeDisplayName
        };
    });
    var regionSummaries = data.nonBenefitPriceTotalSummary.regionSummaries.map(function(regionSummary) {
        return {
            averagePrice: regionSummary.averagePrice,
            minPrice: regionSummary.minPrice,
            treatmentMedicineUnitId: regionSummary.treatmentMedicineUnitId,
            unitDisplayName: regionSummary.unitDisplayName,
            unitTypeDisplayName: regionSummary.unitTypeDisplayName
        };
    });
    return new models_nonBenefit/* NonBenefitPriceSummary */.QG({
        regionSummaries: regionSummaries,
        nationalSummaries: nationalSummaries
    });
};
var useNonBenefitPriceTotalSummary = function(treatmentMedicineId, regionCode) {
    var ref = (0,nonBenefit_gql_impl/* useNonBenefitPriceTotalSummaryQuery */.X9)({
        regionCode: regionCode,
        treatmentMedicineId: treatmentMedicineId
    }, {
        select: parseNonBenefitPriceTotalSummary
    }), tmp = ref.data, nonBenefitPriceTotalSummary = tmp === void 0 ? new models_nonBenefit/* NonBenefitPriceSummary */.QG({
        regionSummaries: [],
        nationalSummaries: []
    }) : tmp;
    return {
        nonBenefitPriceTotalSummary: nonBenefitPriceTotalSummary
    };
};
/* harmony default export */ var nonBenefit_useNonBenefitPriceTotalSummary = (useNonBenefitPriceTotalSummary);
var prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, treatmentMedicineId, regionCode) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(nonBenefit_gql_impl/* useNonBenefitPriceTotalSummaryQuery.getKey */.X9.getKey({
                            regionCode: regionCode,
                            treatmentMedicineId: treatmentMedicineId
                        }), nonBenefit_gql_impl/* useNonBenefitPriceTotalSummaryQuery.fetcher */.X9.fetcher({
                            regionCode: regionCode,
                            treatmentMedicineId: treatmentMedicineId
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function prefetchQuery(queryClient, treatmentMedicineId, regionCode) {
        return _ref.apply(this, arguments);
    };
}();
useNonBenefitPriceTotalSummary.prefetchQuery = prefetchQuery;

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useSearchNonF2fDoctorsForSeoByUser.ts








var parseSearchNonF2fDoctorsForSeoByUser = function(data) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        pages: data.pages.map(function(page) {
            return page.searchNonF2fDoctorsForSeoByUser.map(function(doctor) {
                var ref;
                var _jibunAddress, _roadAddress, _siGunGuName, ref1;
                return new models_nonBenefit/* NonBenefitNonF2fDoctor */.qP({
                    doctorId: doctor.doctorId,
                    name: doctor.name,
                    medicineType: doctor.medicineType,
                    hospitalName: doctor.hospital.hospitalName,
                    publicId: doctor.publicId,
                    hospitalAddress: {
                        jibunAddress: (_jibunAddress = doctor.hospital.hospitalAddress.jibunAddress) !== null && _jibunAddress !== void 0 ? _jibunAddress : "",
                        roadAddress: (_roadAddress = doctor.hospital.hospitalAddress.roadAddress) !== null && _roadAddress !== void 0 ? _roadAddress : "",
                        regionByDepth: {
                            siDoName: doctor.hospital.hospitalAddress.regionByDepth.siDoName,
                            siGunGuName: (_siGunGuName = doctor.hospital.hospitalAddress.regionByDepth.siGunGuName) !== null && _siGunGuName !== void 0 ? _siGunGuName : "",
                            legalEupMyeonDongName: doctor.hospital.hospitalAddress.regionByDepth.legalEupMyeonDongName
                        }
                    },
                    nonBenefitTreatments: doctor.nonBenefitTreatmentsV2.map(function(treatment) {
                        return {
                            nonBenefitTreatmentUnitInfos: treatment.nonBenefitTreatmentUnitInfos.map(function(unitInfo) {
                                return {
                                    originalPrice: unitInfo.originalPrice,
                                    unitDisplayName: unitInfo.unitDisplayName,
                                    treatmentMedicineUnitId: unitInfo.treatmentMedicineUnitId
                                };
                            })
                        };
                    }),
                    profileImageUrl: (ref1 = (ref = doctor.detail) === null || ref === void 0 ? void 0 : ref.profileImageUrl) !== null && ref1 !== void 0 ? ref1 : "",
                    readyForVideoCall: doctor.readyForVideoCall,
                    departments: doctor.departments
                });
            });
        })
    });
};
var useSearchNonF2fDoctorsForSeoByUser = function(request) {
    var contactType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F;
    var data = (0,useInfiniteQuery/* useInfiniteQuery */.N)(nonBenefit_gql_impl/* useSearchNonF2fDoctorsForSeoByUserQuery.getKey */.Y6.getKey({
        request: request,
        contactType: contactType
    }), function(param) {
        var pageParam = param.pageParam;
        return nonBenefit_gql_impl/* useSearchNonF2fDoctorsForSeoByUserQuery.fetcher */.Y6.fetcher({
            request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, request), {
                page: pageParam || 1
            }),
            contactType: contactType
        })();
    }, {
        getNextPageParam: function(lastPage, allPages) {
            if (!lastPage.searchNonF2fDoctorsForSeoByUser.length || lastPage.searchNonF2fDoctorsForSeoByUser.length < request.limit) {
                return undefined;
            }
            return allPages.length + 1;
        },
        staleTime: 1000 * 60 * 5,
        select: parseSearchNonF2fDoctorsForSeoByUser
    }).data;
    var nonBenefitDoctors = (data === null || data === void 0 ? void 0 : data.pages.flatMap(function(doctor) {
        return doctor;
    })) || [];
    return {
        nonBenefitDoctors: nonBenefitDoctors
    };
};
/* harmony default export */ var nonBenefit_useSearchNonF2fDoctorsForSeoByUser = (useSearchNonF2fDoctorsForSeoByUser);
useSearchNonF2fDoctorsForSeoByUser.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, request) {
        var contactType;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    contactType = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F;
                    return [
                        4,
                        queryClient.prefetchInfiniteQuery(nonBenefit_gql_impl/* useSearchNonF2fDoctorsForSeoByUserQuery.getKey */.Y6.getKey({
                            request: request,
                            contactType: contactType
                        }), nonBenefit_gql_impl/* useSearchNonF2fDoctorsForSeoByUserQuery.fetcher */.Y6.fetcher({
                            request: request,
                            contactType: contactType
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, request) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/hooks/search/magazine/useGetKeywordSearchMagazineInfinite.ts + 1 modules
var useGetKeywordSearchMagazineInfinite = __webpack_require__(58104);
// EXTERNAL MODULE: ./src/hooks/search/qna/useGetKeywordQuestionCardInfinite.ts + 1 modules
var useGetKeywordQuestionCardInfinite = __webpack_require__(66127);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/models/ad/list.ts
var list = __webpack_require__(70847);
// EXTERNAL MODULE: ./src/types/magazine.ts
var magazine = __webpack_require__(45162);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(59950);
;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitHomeViewModel.tsx



























var useNonBenefitHomeViewModel = function(client) {
    var ref = (0,useCustomRouter/* default */.Z)(), router = ref.router, moveToPage = ref.moveToPage;
    var ref1 = (0,useModal/* default */.Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var queries = router.query;
    var _treatmentMedicineUnitId = queries.treatmentMedicineUnitId, treatmentMedicineUnitId = _treatmentMedicineUnitId === void 0 ? "" : _treatmentMedicineUnitId, _regionCode = queries.regionCode, regionCode = _regionCode === void 0 ? "" : _regionCode;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var breadCrumbs = [
        {
            label: "비급여 진료비",
            url: common/* ROUTES.NON_BENEFIT.HOME.path */.Z6.NON_BENEFIT.HOME.path + (0,url/* addQueryString */.sC)(queries),
            logName: "non_benefit_home"
        }, 
    ];
    var ref2 = (0,react.useState)(false), isAddressFilterModalOpen = ref2[0], setIsAddressFilterModalOpen = ref2[1];
    var ref3 = (0,react.useState)(true), isEnableQnaPagination = ref3[0], setIsEnableQnaPagination = ref3[1];
    var ref4 = (0,useAdBanner/* default */.Z)(list/* AdPageType.NonBenefitDetail */.hO.NonBenefitDetail, client), bannerAdExchange = ref4.bannerAdExchange, handleSendExposureLog = ref4.handleSendExposureLog;
    /* 비급여 목록 */ var nonBenefitMedicines = nonBenefit_useNonBenefitMedicinesForSeo().nonBenefitMedicines;
    var invitationCode = (0,useGetNonBenefitDiagnosisPriceSupportInvitationCode/* default */.Z)().invitationCode;
    /* 선택된 비급여 및 비급여 유닛 */ var selectedMedicine = nonBenefitMedicines.findMedicineByTreatmentMedicineUnitId(treatmentMedicineUnitId);
    var selectedMedicineUnit = nonBenefitMedicines.findMedicineUnitByTreatmentMedicineUnitId(treatmentMedicineUnitId);
    /* 비급여 가격 정보 */ var nonBenefitPriceTotalSummary = nonBenefit_useNonBenefitPriceTotalSummary(selectedMedicine.id, regionCode).nonBenefitPriceTotalSummary;
    var selectedRegionSummary = nonBenefitPriceTotalSummary.getSelectedRegionSummaryByTreatmentMedicineUnitId(treatmentMedicineUnitId);
    var priceDisplayGapText = nonBenefitPriceTotalSummary.getComparePriceDisplayGapText(treatmentMedicineUnitId);
    /* 비급여 검색 결과 의사리스트 */ var nonBenefitDoctors = nonBenefit_useSearchNonF2fDoctorsForSeoByUser({
        regionCode: regionCode,
        treatmentMedicineUnitId: treatmentMedicineUnitId,
        limit: 3,
        page: 1
    }).nonBenefitDoctors;
    /* 지역 검색 */ var queryRegion = new models_nonBenefit/* Region */.yp(regionCode);
    var ref5 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: null,
        siGunGuCode: null
    }), tmp = ref5.data, siDoList = tmp === void 0 ? [] : tmp;
    var ref6 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: queryRegion.excludeSejongSiDoRegionCode(),
        siGunGuCode: null
    }), tmp1 = ref6.data, siGunGuList = tmp1 === void 0 ? [] : tmp1;
    var ref7 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: queryRegion.regionCodes.siDoCode,
        siGunGuCode: queryRegion.excludeSejongSiGunGuRegionCode()
    }), tmp2 = ref7.data, dongList = tmp2 === void 0 ? [] : tmp2;
    /* 선택된 지역 */ var koreaAddress = new models_nonBenefit/* KoreaAddress */.cZ(siDoList, siGunGuList, dongList);
    var selectedAddressList = koreaAddress.getSelectedRegionByDepth(queryRegion);
    var selectedAddressTitle = koreaAddress.getAddressTitle(queryRegion);
    var selectedFullAddressTitle = koreaAddress.getFullAddressTitle(queryRegion);
    /* 관련 컨텐츠 및 QNA */ var ref8 = (0,useGetKeywordSearchMagazineInfinite/* default */.Z)({
        keyword: selectedMedicine.treatment.name,
        size: 7,
        contentType: magazine/* MagazineType.FAQ */.rL.FAQ
    }), faqs = ref8.magazines;
    var magazines = (0,useGetKeywordSearchMagazineInfinite/* default */.Z)({
        keyword: selectedMedicine.treatment.name,
        size: 7,
        contentType: magazine/* MagazineType.ARTICLE */.rL.ARTICLE
    }).magazines;
    var ref9 = (0,useGetKeywordQuestionCardInfinite/* default */.Z)({
        keyword: selectedMedicine.treatment.name,
        size: 5
    }), qnas = ref9.qnas, fetchSearchedQnaNextPage = ref9.fetchSearchedQnaNextPage;
    var onUpdateAddress = function(item) {
        router.replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), {
                regionCode: item.regionCode
            })
        });
    };
    var onSelectAddress = function(item) {
        onUpdateAddress(item);
        onCloseSearchAddressFilterModal();
    };
    var selectMedicine = function(item) {
        router.replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), {
                treatmentMedicineUnitId: item.units[0].id
            })
        });
        closeModal();
    };
    var selectMedicineUnit = function(item) {
        router.replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), {
                treatmentMedicineUnitId: item.id
            })
        });
        closeModal();
    };
    var onCloseSearchAddressFilterModal = function() {
        setIsAddressFilterModalOpen(false);
    };
    var onOpenSearchAddressFilterModal = function() {
        setIsAddressFilterModalOpen(true);
    };
    var onOpenMedicineFilterModal = function() {
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitFilterModal, {
                    title: "진료 종류를 선택해주세요",
                    list: nonBenefitMedicines.medicines,
                    onClick: selectMedicine,
                    selectedItem: selectedMedicine,
                    getItemName: function(item) {
                        return item.medicineName;
                    }
                }),
                onClickOverlay: closeModal
            }
        });
    };
    var onOpenMedicineUnitFilterModal = function() {
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitFilterModal, {
                    title: "처방 단위를 선택해주세요",
                    /* 처방 단위를 최대 3개까지 노출하기로 함 */ list: selectedMedicine.units.slice(0, 3),
                    onClick: selectMedicineUnit,
                    selectedItem: selectedMedicineUnit,
                    getItemName: function(item) {
                        return "".concat(item.unit).concat(item.unitTypeDisplayName);
                    }
                }),
                onClickOverlay: closeModal
            }
        });
    };
    var onClickRelatedMagazine = function(magazinePid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazinePid),
            mobileScreenName: common/* ROUTES.MAGAZINE.DETAIL.appScreenName */.Z6.MAGAZINE.DETAIL.appScreenName,
            params: {
                id: magazinePid
            }
        });
    };
    var onClickRelatedFaq = function(magazinePid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(magazinePid),
            mobileScreenName: common/* ROUTES.FAQ.DETAIL.appScreenName */.Z6.FAQ.DETAIL.appScreenName,
            params: {
                id: magazinePid
            }
        });
    };
    var onClickRelatedQuestion = function(questionPid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionPid),
            mobileScreenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
            params: {
                questionId: questionPid
            }
        });
    };
    var onClickOpenAppInstallLink = function() {
        airbridge/* default.setDeepLink */.Z.setDeepLink({
            buttonID: "selected-medicine-".concat(selectedMedicine.id),
            deeplinkUrl: "".concat(selectedMedicine.deepLinkUrl).concat(invitationCode ? "&invitationCode=".concat(invitationCode) : ""),
            ctaParams: {
                cta_param_1: "우리동네진료가격",
                cta_param_2: selectedMedicine.medicineName,
                cta_param_3: selectedMedicine.treatment.name
            }
        });
    };
    var onClickDoctor = function(doctor, medicine) {
        router.push("".concat(common/* ROUTES.DOCTOR.DETAIL.path */.Z6.DOCTOR.DETAIL.path, "/").concat(doctor.publicId).concat((0,url/* addQueryString */.sC)({
            type: "treatment",
            categoryId: medicine.treatment.id,
            treatmentMedicineId: medicine.id
        })));
    };
    var onClickCopyInvitationCode = function() {
        if (navigator.clipboard) {
            toast({
                text: "복사가 완료되었습니다"
            });
            navigator.clipboard.writeText(invitationCode !== null && invitationCode !== void 0 ? invitationCode : "");
        }
    };
    var onOpenDiagnosisAppInstallBottomSheet = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.BottomCtaClick */.$.BottomCtaClick, {
            region: selectedAddressTitle,
            drug: selectedMedicine.medicineName
        });
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiagnosisAppInstallBottomSheet/* default */.Z, {
                    client: client,
                    treatmentMedicineId: selectedMedicine.id,
                    treatmentProductMedicineName: selectedMedicine.treatmentProductMedicineName,
                    invitationCode: invitationCode,
                    onClose: closeModal,
                    qrCodeUrl: "".concat(selectedMedicine.installQrcodeUrl).concat(invitationCode ? "?invitationCode=".concat(invitationCode) : ""),
                    onClickOpenAppInstallLink: onClickOpenAppInstallLink,
                    onClickCopyInvitationCode: onClickCopyInvitationCode
                })
            }
        });
    };
    var onClickNextQna = lodash_default().debounce(function() {
        if (!isEnableQnaPagination) {
            return;
        }
        fetchSearchedQnaNextPage();
        setIsEnableQnaPagination(false);
    }, 1000, {
        leading: true,
        trailing: false
    });
    var getSearchAddressFilterModalProps = function() {
        return {
            switchRegionFilter: onCloseSearchAddressFilterModal,
            siDoList: siDoList,
            siGunGuList: siGunGuList,
            dongList: dongList,
            selectedRegion: selectedAddressList,
            onSelectAddress: onSelectAddress,
            onUpdateAddress: onUpdateAddress,
            isOpened: true,
            isSejong: queryRegion.isSejongRegion,
            client: client
        };
    };
    var onClickTopCta = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.TopCtaClick */.$.TopCtaClick, {
            region: selectedAddressTitle,
            drug: selectedMedicine.medicineName
        });
    };
    (0,react.useEffect)(function() {
        /* 카테고리 변경시 qna 페이지네이션 재허용 */ setIsEnableQnaPagination(true);
    }, [
        selectedMedicine.treatment.id
    ]);
    (0,react.useEffect)(function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, {
            region: selectedAddressTitle,
            drug: selectedMedicine.medicineName
        });
    }, [
        selectedMedicine,
        selectedAddressTitle
    ]);
    return {
        bannerAdExchange: bannerAdExchange,
        breadCrumbs: breadCrumbs,
        queries: queries,
        qnas: qnas,
        faqs: faqs,
        magazines: magazines,
        isEnableQnaPagination: isEnableQnaPagination,
        nonBenefitPriceTotalSummary: nonBenefitPriceTotalSummary,
        nonBenefitMedicines: nonBenefitMedicines,
        koreaAddress: koreaAddress,
        queryRegion: queryRegion,
        nonBenefitDoctors: nonBenefitDoctors,
        selectedAddressList: selectedAddressList,
        selectedMedicine: selectedMedicine,
        selectedAddressTitle: selectedAddressTitle,
        selectedFullAddressTitle: selectedFullAddressTitle,
        selectedMedicineUnit: selectedMedicineUnit,
        selectedRegionSummary: selectedRegionSummary,
        priceDisplayGapText: priceDisplayGapText,
        isAddressFilterModalOpen: isAddressFilterModalOpen,
        onClickNextQna: onClickNextQna,
        handleSendExposureLog: handleSendExposureLog,
        onOpenSearchAddressFilterModal: onOpenSearchAddressFilterModal,
        onOpenMedicineFilterModal: onOpenMedicineFilterModal,
        onOpenMedicineUnitFilterModal: onOpenMedicineUnitFilterModal,
        onClickRelatedMagazine: onClickRelatedMagazine,
        onClickRelatedFaq: onClickRelatedFaq,
        onClickRelatedQuestion: onClickRelatedQuestion,
        onClickDoctor: onClickDoctor,
        onOpenDiagnosisAppInstallBottomSheet: onOpenDiagnosisAppInstallBottomSheet,
        getSearchAddressFilterModalProps: getSearchAddressFilterModalProps,
        onClickTopCta: onClickTopCta
    };
};
/* harmony default export */ var nonBenefit_useNonBenefitHomeViewModel = (useNonBenefitHomeViewModel);

;// CONCATENATED MODULE: ./src/pages/non-benefit/index.tsx
// PageDescription: 지역별 비급여 가격비교 페이지











var NonBenefitHomePages = function(param) {
    var client = param.client;
    var viewModel = nonBenefit_useNonBenefitHomeViewModel(client);
    var topBannerViewModel = (0,useAppInstallTopBanner/* default */.Z)(client);
    var _queries = viewModel.queries, treatmentMedicineUnitId = _queries.treatmentMedicineUnitId, regionCode = _queries.regionCode;
    var title = "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 최저가 가격 ").concat(viewModel.selectedMedicine.medicineName, " 2025");
    var description = "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " ").concat(viewModel.selectedMedicine.medicineName, " 성지 병원 가격 비교 - ").concat(viewModel.selectedMedicine.medicineProductName);
    var canonical = "".concat("https://doctornow.co.kr").concat(common/* ROUTES.NON_BENEFIT.HOME.path */.Z6.NON_BENEFIT.HOME.path).concat((0,url/* addQueryString */.sC)({
        treatmentMedicineUnitId: treatmentMedicineUnitId,
        regionCode: regionCode
    }));
    var nonBenefitLdJson = (0,react.useMemo)(function() {
        return (0,format/* nonBenefitSeoLdJson */.r3)({
            doctors: viewModel.nonBenefitDoctors,
            address: viewModel.selectedAddressTitle,
            faqs: viewModel.faqs,
            canonical: canonical
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: description,
                canonical: canonical,
                openGraph: {
                    title: title,
                    description: description,
                    url: canonical,
                    images: [
                        {
                            url: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-main.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(nonBenefitLdJson)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_NonBenefitHomeTemplate, {
                client: client,
                viewModel: viewModel,
                topBannerViewModel: topBannerViewModel
            })
        ]
    });
};
NonBenefitHomePages.Layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var non_benefit = (NonBenefitHomePages);


/***/ }),

/***/ 15951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ep": function() { return /* binding */ appInstallTopBannerState; },
/* harmony export */   "Ih": function() { return /* binding */ setAppDownloadCujModalState; },
/* harmony export */   "Ze": function() { return /* binding */ appDownloadCujModalState; },
/* harmony export */   "_l": function() { return /* binding */ getAppInstallTopBannerState; },
/* harmony export */   "dl": function() { return /* binding */ hideBanner; }
/* harmony export */ });
/* unused harmony exports CujTestDateState, getCujTestDateState, setCujTestDateState, setBannerState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80888);




var CujTestDateState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "testDate",
    default: [],
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .localStorageEffect */ .N)("testCujDate")
    ]
});
var getCujTestDateState = function() {
    return getRecoil(CujTestDateState);
};
var setCujTestDateState = function(date) {
    setRecoil(CujTestDateState, date);
};
var appDownloadCujModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appDownloadCujModalState",
    default: {
        isShow: false
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appDownLoadCujModal")
    ]
});
var appInstallTopBannerState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appInstallTopBannerStateType",
    default: {
        isVisible: false,
        expirationTime: undefined
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appInstallTopBanner")
    ]
});
var setAppDownloadCujModalState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appDownloadCujModalState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var getAppInstallTopBannerState = function() {
    var state = (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .getRecoil */ .$l)(appInstallTopBannerState);
    if (state.expirationTime === undefined) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    if (state.expirationTime && new Date() > new Date(state.expirationTime)) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    return state;
};
// 배너 상태를 설정하는 함수
var setBannerState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appInstallTopBannerState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var hideBanner = function() {
    var expirationTime = new Date(new Date().getTime() + 30 * 60 * 1000).toISOString(); // 30분
    setBannerState({
        isVisible: false,
        expirationTime: expirationTime
    });
};


/***/ }),

/***/ 45162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tq": function() { return /* binding */ AuthorType; },
/* harmony export */   "Zg": function() { return /* binding */ MagazineTagType; },
/* harmony export */   "pO": function() { return /* binding */ EDoctorCareer; },
/* harmony export */   "rL": function() { return /* binding */ MagazineType; },
/* harmony export */   "wK": function() { return /* binding */ MagazineBottomButtonType; }
/* harmony export */ });
/* unused harmony export CoreCategoryType */
var MagazineType = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL",
    ARTICLE: "ARTICLE",
    FAQ: "FAQ"
};
var MagazineTagType;
(function(MagazineTagType) {
    MagazineTagType["DEPARTMENT"] = "DEPARTMENT";
    MagazineTagType["SYMPTOM"] = "SYMPTOM";
    MagazineTagType["DISEASE"] = "DISEASE";
    MagazineTagType["FREE"] = "FREE";
})(MagazineTagType || (MagazineTagType = {}));
var CoreCategoryType;
(function(CoreCategoryType) {
    CoreCategoryType["Department"] = "DEPARTMENT";
    CoreCategoryType["Disease"] = "DISEASE";
    CoreCategoryType["Symptom"] = "SYMPTOM";
})(CoreCategoryType || (CoreCategoryType = {}));
var AuthorType;
(function(AuthorType) {
    AuthorType["DOCTOR"] = "DOCTOR";
    AuthorType["AI"] = "AI";
    AuthorType["NURSE"] = "NURSE";
    AuthorType["MEDICAL_PROFESSIONAL_EDITOR"] = "MEDICAL_PROFESSIONAL_EDITOR";
    AuthorType["GENERAL_EDITOR"] = "GENERAL_EDITOR";
})(AuthorType || (AuthorType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["DEPARTMENT"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var MagazineBottomButtonType;
(function(MagazineBottomButtonType) {
    MagazineBottomButtonType["QUESTION"] = "QUESTION";
    MagazineBottomButtonType["DIAGNOSIS"] = "DIAGNOSIS";
})(MagazineBottomButtonType || (MagazineBottomButtonType = {}));
var EDoctorCareer;
(function(EDoctorCareer) {
    EDoctorCareer["CURRENT"] = "CURRENT";
    EDoctorCareer["PAST"] = "PAST";
    EDoctorCareer["GRADUATION"] = "GRADUATION";
    EDoctorCareer["COMPLETION"] = "COMPLETION";
})(EDoctorCareer || (EDoctorCareer = {}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2182,1498,4330,5615,1743,7743,8652,9535,5247,4520,203,8735,2935,5311,9774,2888,179], function() { return __webpack_exec__(45971); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);